module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.list.length > 0) ? _c('div', [_c('swiper', {
    ref: "mySwiperad",
    staticClass: "swiper-Container",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('a', {
      staticClass: "swiper-Container-a",
      attrs: {
        "href": item.contentUrl || '##'
      }
    }, [_c('img', {
      attrs: {
        "src": item.imgUrl,
        "alt": ""
      }
    })])])
  }))], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-500afade"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/swiper/Adswiper.vue
// module id = 323
// module chunks = 1